import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { LargeContentBox } from "@/components/common";
import { PageHeader } from "@/components/common/PageHeader";
import { ScreenMobile } from "@/components/common/ScreenMobile";
import { CannabisIcon } from "@/components/icons/CannabisIcon";
import { useSessionContext } from "@/contexts/SessionContext";
import { PatientSupportingDocumentsPanel } from "@/pages/home/components/PatientDash/components/patientSupportingDocuments";

export function PatientSupportingDocumentsPage() {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { user } = useSessionContext();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/home");
    }
  };

  const panel = (
    <PatientSupportingDocumentsPanel
      userId={user?.username}
      layout="page"
      showHeader={false}
    />
  );

  if (isMobileLayout) {
    return (
      <ScreenMobile
        title="Tratamento canabinoide"
        subtitle="Envie ou edite arquivos para agendamentos"
        open={open}
        onClose={handleClose}
      >
        <Box sx={{ px: 1.5, pt: 0.5, pb: 3 }}>{panel}</Box>
      </ScreenMobile>
    );
  }

  return (
    <LargeContentBox>
      <Stack width="100%" spacing={2} sx={{ overflow: "auto" }}>
        <PageHeader
          title="Tratamento canabinoide"
          icon={CannabisIcon}
          description="Gerencie os documentos para o seu tratamento canabinoide"
        />
        <Box sx={{ width: "100%" }}>{panel}</Box>
      </Stack>
    </LargeContentBox>
  );
}
